import React from "react"
function CopyIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 14" fill="none">
			<path
				fill="#051D27"
				d="M4 11c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.942v-8c0-.366.13-.68.391-.941C3.32.464 3.633.333 4 .333h6c.367 0 .68.13.942.392.26.26.391.575.391.941v8c0 .367-.13.68-.391.942A1.284 1.284 0 0 1 10 11H4Zm0-1.334h6v-8H4v8Zm-2.667 4c-.366 0-.68-.13-.941-.391A1.284 1.284 0 0 1 0 12.333V3h1.333v9.333h7.334v1.333H1.333Z"
			/>
		</svg>
	)
}

export default CopyIcon
